/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewStatsResponse
 */
export interface CRSFSecReviewStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewStatsResponse
     */
    assets_count: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewStatsResponse
     */
    claims_benchmark: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewStatsResponse
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewStatsResponse
     */
    dataleaks_count: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewStatsResponse
     */
    process_id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewStatsResponse
     */
    surface: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewStatsResponse
     */
    vulnerabilities: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewStatsResponse
     */
    vulnerabilities_count: number;
}

/**
 * Check if a given object implements the CRSFSecReviewStatsResponse interface.
 */
export function instanceOfCRSFSecReviewStatsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets_count" in value;
    isInstance = isInstance && "claims_benchmark" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "dataleaks_count" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "surface" in value;
    isInstance = isInstance && "vulnerabilities" in value;
    isInstance = isInstance && "vulnerabilities_count" in value;

    return isInstance;
}

export function CRSFSecReviewStatsResponseFromJSON(json: any): CRSFSecReviewStatsResponse {
    return CRSFSecReviewStatsResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets_count': json['assets_count'],
        'claims_benchmark': json['claims_benchmark'],
        'created': json['created'],
        'dataleaks_count': json['dataleaks_count'],
        'process_id': json['process_id'],
        'surface': json['surface'],
        'vulnerabilities': json['vulnerabilities'],
        'vulnerabilities_count': json['vulnerabilities_count'],
    };
}

export function CRSFSecReviewStatsResponseToJSON(value?: CRSFSecReviewStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets_count': value.assets_count,
        'claims_benchmark': value.claims_benchmark,
        'created': value.created,
        'dataleaks_count': value.dataleaks_count,
        'process_id': value.process_id,
        'surface': value.surface,
        'vulnerabilities': value.vulnerabilities,
        'vulnerabilities_count': value.vulnerabilities_count,
    };
}

